import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

/**
 * Small reusable footer line shown on the new invitation-link error pages.
 * Tells users where to escalate when the self-service flow can't recover them.
 *
 * Used on:
 *  - /invitation-expired   (alongside the "Request new link" button)
 *  - /invitation-invalid   (as the primary recovery affordance)
 *
 * @param {object} props
 * @param {string} [props.className] - Optional extra Tailwind classes.
 * @param {string} [props.prefix="Still can't get in?"] - Leading sentence
 *   before the email link. Override on pages where a different lead reads more
 *   naturally (e.g., "Need help?").
 */
const SUPPORT_EMAIL = "product@dashmote.com";

const SupportContact = ({
  className = "",
  prefix = "Still can't get in?",
}) => (
  <Text
    className={`!text-[14px] !leading-[22px] !text-[rgba(0,0,0,0.45)] font-normal ${className}`}
  >
    {prefix} Email{" "}
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      className="!text-[#0E49B5] hover:!underline"
    >
      {SUPPORT_EMAIL}
    </a>{" "}
    for help.
  </Text>
);

export default SupportContact;
